<div class="sidebar" *ngIf="showSidebarSkeleton">
  <div class="sidebar-skeleton">
    <div class="sidebar-skeleton-user">
      <app-skeleton className="h-96 w-96 r-50%" extraClassName="mx-auto"></app-skeleton>
      <app-skeleton className="h-24 w-100% r-28" extraClassName="mt-4"></app-skeleton>
    </div>
    <div *ngFor="let item of [1, 2]" class="sidebar-newpost mt-3">
      <app-skeleton className="h-36 w-100% r-28"></app-skeleton>
    </div>
    <div class="sidebar-nav mt-3">
      <ul>
        <li *ngFor="let item of [1, 2, 3, 4]">
          <app-skeleton className="h-28 w-100% r-28" extraClassName="mb-3"></app-skeleton>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-container *ngIf="cs.isBrowser">
  <div
    [style]="desktopStickyStyles"
    class="sidebar"
  >
    <div
      class="pwa-install-bar"
      *ngIf="!mobileBridgeService.isMobileApp && pwaService?.pwaMetaData?.showInstallButton && cs.updateSignInVisibility()"
      [ngClass]="{ 'white-site-label-bg': whiteLabelConfig }"
    >
      <div
        class="d-flex gap-3 cursor-pointer align-items-center"
        (click)="!pwaService.isIosDevice && pwaService.installPWA()"
      >
        <div class="topfan-logo" *ngIf="!(whiteLabelConfigData?.profile_image_url || whiteLabelConfig?.logo_url)">
          <img 
            src="/assets/images/svg/topfan-circular.svg"
            [alt]="SIDEBAR_CONSTANTS.alt.TOPFAN_LOGO"
            loading="lazy"
            decoding="async" 
          />
        </div>
        <div *ngIf="whiteLabelConfigData?.profile_image_url || whiteLabelConfig?.logo_url">
          <img
            appDisableRightClick
            appMobileOptimization
            [originalUrl]="whiteLabelConfigData?.profile_image_url || whiteLabelConfig?.logo_url"
            [src]="whiteLabelConfigData?.profile_image_url || whiteLabelConfig?.logo_url"
            [width]="pwaService.isIosDevice ? 90 : 55"
            [ngClass]="pwaService.isIosDevice ? 'white-label-logo-ios' : 'white-label-logo'"
            [format]="'webp'"
            [alt]="SIDEBAR_CONSTANTS.alt.LOGO"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div [ngClass]="whiteLabelConfig ? 'white-label-text' : 'label-text'" *ngIf="!pwaService.isIosDevice">
          {{ commonEnums.ADD_APP_TO_HOME_SCREEN }}
        </div>
        <div [ngClass]="whiteLabelConfig ? 'white-label-text' : 'label-text'" *ngIf="pwaService.isIosDevice">
          <span class="label-span">
            {{ whiteLabelConfig ? commonEnums.INSTALL_WEBAPP_IN_IPHONE_WLS : commonEnums.INSTALL_WEBAPP_IN_IPHONE }}
          </span>&nbsp;
          <span>
            <em class="icon-liteEi-share-apple-1-3" [ngClass]="whiteLabelConfig ? 'wls-export-icon-size' : 'export-icon-size'"></em>
          </span>
          <span class="label-span">{{ commonEnums.ICON_AND }}</span>&nbsp;
          <span>
            <em class="icon-litePlus-1" [ngClass]="whiteLabelConfig ? 'wls-add-to-home-icon' : 'add-to-home-icon'"></em>
          </span>
          <span class="label-span">{{ commonEnums.ADD_TO_HOME }}</span>
        </div>
      </div>
      <div (click)="pwaService.closePwaBar()">
        <img class="icon-cross" *ngIf="!whiteLabelConfig" src='/assets/images/close_icon_top.png' />
        <em class="icon-liteicon-close" *ngIf="whiteLabelConfig"></em>
      </div>
    </div>
    <link
      rel="preload"
      href="./assets/images/svg/red-info-blank.svg"
      as="image"
      type="image/svg+xml"
    />
    <link
      rel="preload"
      href="./assets/images/svg/pending.svg"
      as="image"
      type="image/svg+xml"
    />
    <link
      rel="preload"
      href="./assets/images/svg/checkmark-outline.svg"
      as="image"
      type="image/svg+xml"
    />
    <link
      rel="preload"
      href="./assets/images/svg/schedule.svg"
      as="image"
      type="image/svg+xml"
    />
    <link
      rel="preload"
      href="./assets/images/svg/arrow-up-right.svg"
      as="image"
      type="image/svg+xml"
    />
    <link
      rel="preload"
      href="./assets/images/svg/shield-tick.svg"
      as="image"
      type="image/svg+xml"
    />
    <link
      rel="preload"
      href="./assets/images/svg/delegate-not-found.svg"
      as="image"
      type="image/svg+xml"
    />
    <div class="sidebar-without-login" *ngIf="!authService.isLogin && cs.updateSignInVisibility()">
      <div class="cards">
        <a class="btn btn-secondary" [routerLink]="'/auth/login'">
          {{ SIDEBAR_CONSTANTS.labels.SIGN_IN }}
        </a>
        <p>{{ SIDEBAR_CONSTANTS.labels.OR }}</p>
        <a class="btn btn-primary mb-3" [routerLink]="'/auth/signup'">
          {{ SIDEBAR_CONSTANTS.labels.CREATE_NEW_ACCOUNT }}
        </a>
        <p class="terms-and-privacy-links mt-0 mb-0">
          <a [routerLink]="['/', ROUTES.TERMS_OF_SERVICE]">
            {{ legalLinkLabels.TERMS }}
          </a>
          {{ legalLinkLabels.SEPARATOR }}
          <a [routerLink]="['/', ROUTES.PRIVACY_POLICY]">
            {{ legalLinkLabels.PRIVACY_POLICY }}
          </a>
        </p>
        <p class="terms-and-privacy-links mb-0">
          <a [routerLink]="['/', ROUTES.HELP_FAQ]">
            {{ legalLinkLabels.HELP_CENTER_FAQ }}
          </a>
        </p>
      </div>
    </div>

    <div class="sidebar-user" *ngIf="authService.isLogin && !(isSidebarLoading && isWhiteLabel) && userProfile">
      <app-user-profile></app-user-profile>
    </div>
    <div
      *ngIf="
        authService.isLogin &&
        !(isSidebarLoading && isWhiteLabel) &&
        (((permissionKeys.NEW_POST | hasPermission | async) &&
          (permissionKeys.MAKE_EDIT_FEED_POSTS
            | hasPermission: PERMISSION_TYPE.READ : true
            | async) &&
          !isWhiteLabel) ||
        (!isWhiteLabel && userProfile?.is_host_owner) ||
        (isWhiteLabel && userProfile?.gsi4pk === whiteLabelConfigData?.gsi4pk)) &&
        (userProfile | showTabByApproval : SIDEBAR_TABS.NEW_POST)
      "
      class="sidebar-newpost"
    >
      <a [routerLink]="['/dashboard/newpost']" class="btn btn-primary">
        <em class="icon-newpost-plus"></em>
        <span>{{ SIDEBAR_CONSTANTS.labels.NEW_POST }}</span>
      </a>
    </div>
    <div
      *ngIf="
        authService.isLogin &&
        !(isSidebarLoading && isWhiteLabel) &&
        (((permissionKeys.NEW_POST | hasPermission | async) &&
        !userProfile?.delegate_user?.type?.length &&
          (permissionKeys.MAKE_EDIT_FEED_POSTS
            | hasPermission: PERMISSION_TYPE.READ : true
            | async) &&
          !isWhiteLabel) ||
        (!isWhiteLabel && userProfile?.is_host_owner) ||
        (isWhiteLabel && userProfile?.gsi4pk === whiteLabelConfigData?.gsi4pk)) &&
        (userProfile | showTabByApproval : SIDEBAR_TABS.LIVE_STREAM)
      "
      class="sidebar-newpost pad-top-10"
    >
      <a (click)="navigateToLiveStream()" class="btn btn-primary">
        <em class="icon-liteVideo-1"></em>
        <span>{{ postType.LIVE_STREAM }}</span>
      </a>
    </div>
    <div
      class="mt-6 sidebar-newpost"
      *ngIf="
        authService.isLogin &&
        !(isSidebarLoading && isWhiteLabel) &&
        isEditPreferencePage &&
        !isCreatorRequestApproved &&
        !userProfile?.is_creator &&
        userProfile?.isAbove18 &&
        !isWhiteLabel
        && (userProfile | showTabByApproval : SIDEBAR_TABS.CREATE_ON_TOPFANS)
      "
    >
      <app-button
        (click)="navigateToBecomeACreatorPage()"
        [btnField]="{
          label: CREATORS_CONST.BECOME_A_CREATOR,
          class: isCreatorRequestResubmitted
            ? 'btn btn-primary btn-outlined w-100'
            : isCreatorRequestPending || isCreatorRequestFailed
              ? 'btn btn-primary btn-outlined w-100 fade-out'
              : 'btn btn-primary btn-outlined w-100',
          disabled: isCreatorRequestResubmitted
            ? false
            : isCreatorRequestPending || isCreatorRequestFailed
        }"
      ></app-button>
    </div>
    <div class="sidebar-nav" *ngIf="showSidebarNav">
      <ul>
        <li *ngIf="showImmediatePwaNav || showGuestMobileNav || (showLoggedInNav && (permissionKeys.HOME | hasPermission | async) && (userProfile | showTabByApproval : SIDEBAR_TABS.HOME))">
          <a
            *ngIf="!isWhiteLabel"
            [routerLink]="['/dashboard/posts']"
            [routerLinkActiveOptions]="{ exact: false }"
            routerLinkActive="active"
          >
            <em class="icon-home"></em>
            <span>{{ SIDEBAR_CONSTANTS.labels.HOME }}</span>
          </a>
          <a
            *ngIf="isWhiteLabel"
            [routerLink]="['']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
          >
            <em class="icon-home"></em>
            <span>{{ SIDEBAR_CONSTANTS.labels.HOME }}</span>
          </a>
        </li>
        <li
          *ngIf="
            showWhiteLabelFeedNav &&
            (showImmediatePwaNav ||
              showGuestMobileNav ||
              (showLoggedInNav &&
                (permissionKeys.HOME | hasPermission | async) &&
                (userProfile | showTabByApproval : SIDEBAR_TABS.HOME)))
          "
        >
          <a
            [routerLink]="[whiteLabelFeedRoute]"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
          >
            <em class="icon-litefeed-content"></em>
            <span>{{ contentFeedLabel }}</span>
          </a>
        </li>
        <li *ngIf="showImmediatePwaNav || showGuestMobileNav || (showLoggedInNav && (permissionKeys.ACTIVITY | hasPermission | async) && (userProfile | showTabByApproval : SIDEBAR_TABS.ACTIVITY))">
          <a
            [routerLink]="showGuestMobileNav ? null : ['/dashboard/activity']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            (click)="onRestrictedNavClick($event)"
          >
            <em class="icon-notification"></em>
            <span>{{ SIDEBAR_CONSTANTS.labels.ACTIVITY }}</span>
            <div
              *ngIf="!showGuestMobileNav && userBadges?.unreadActivityCount"
              class="sidebar-nav-notification number-count"
            >
              {{ userBadges?.unreadActivityCount }}
            </div>
          </a>
        </li>
        <li
          *ngIf="
            showLoggedInNav &&
            (permissionKeys.MESSAGES | hasPermission | async) &&
            (permissionKeys.SEND_REPLY_TO_DIRECT_MESSAGES
              | hasPermission: PERMISSION_TYPE.READ : true
              | async) && (userProfile | showTabByApproval : SIDEBAR_TABS.MESSAGES)
          "
          class="d-none d-lg-block"
        >
          <a
            [routerLink]="['/messages']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            class="message-icon"
          >
            <em class="icon-message"></em>
            <span>{{ SIDEBAR_CONSTANTS.labels.MESSAGES }}</span>
            <div
              *ngIf="userBadges?.messageCount"
              class="sidebar-nav-notification number-count"
            >
              {{ userBadges?.messageCount }}
            </div>
          </a>
        </li>
        <li
          *ngIf="
            showGuestCreatorsNav ||
            (showImmediatePwaNav && !isWhiteLabel) ||
            (showLoggedInNav &&
            (permissionKeys.CREATORS | hasPermission | async) &&
            (!userProfile?.is_white_label || userProfile?.is_host_owner) &&
            !isWhiteLabel && (userProfile | showTabByApproval : SIDEBAR_TABS.CREATORS))
          "
        >
          <a
            [routerLink]="showGuestMobileNav ? null : [ROUTES.EXPLORE_CREATORS]"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            (click)="showGuestMobileNav ? onRestrictedNavClick($event) : resetCreatorSubTabs()"
          >
            <em class="icon-club"></em>
            <span>{{ SIDEBAR_CONSTANTS.labels.CREATORS }}</span>
          </a>
        </li>
        <li
          *ngIf="
            showLoggedInNav &&
            (((permissionKeys.MONETIZE | hasPermission | async) &&
              ((permissionKeys.ADD_EDIT_STORE_ITEMS_VIP_OFFERS_AND_EVENTS
                | hasPermission: PERMISSION_TYPE.READ : true
                | async) ||
                (permissionKeys.ADD_EDIT_SUBSCRIPTION_ITEMS
                  | hasPermission: PERMISSION_TYPE.READ : true
                  | async)) &&
              !userProfile?.is_white_label) ||
            userProfile?.is_host_owner) && (userProfile | showTabByApproval : SIDEBAR_TABS.MONETIZE)
          "
          class="sidebar-nav-monetize"
        >
          <a
            [routerLink]="[
              (permissionKeys.ADD_EDIT_SUBSCRIPTION_ITEMS
              | hasPermission: PERMISSION_TYPE.READ : true
              | async)
                ? '/monetize/subscription'
                : '/monetize/experience'
            ]"
            [ngClass]="{ active: getRouteStatusForMonetize }"
          >
            <em class="icon-liteicon-monetize"></em>
            <span>{{ SIDEBAR_CONSTANTS.labels.MONETIZE }}</span>
          </a>
        </li>
        <li *ngIf="showImmediatePwaNav || showGuestMobileNav || (showLoggedInNav && (permissionKeys.WALLET | hasPermission | async) && (userProfile | showTabByApproval : SIDEBAR_TABS.WALLET))">
          <a
            [routerLink]="showGuestMobileNav ? null : [walletRoute]"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="onRestrictedNavClick($event)"
            [ngClass]="{
              active1: getRouteStatus(),
              active: getRouteStatus()
                ? 'list-group-item'
                : getRouteStatusForWallet()
                  ? 'list-group-item'
                  : ''
            }"
            routerLinkActive="active"
          >
            <em class="icon-wallet"></em>
            <span>{{ SIDEBAR_CONSTANTS.labels.WALLET }}</span>
            <div
              *ngIf="
                !showGuestMobileNav &&
                (userBadges?.my_fulfillment_requests_count ||
                userBadges?.refund_requests_count ||
                userBadges?.merchandise_awaiting_fan_confirmation_count ||
                userBadges?.experience_awaiting_fan_confirmation_count)
              "
              class="sidebar-nav-notification number-count"
            >
              {{
                (userBadges?.my_fulfillment_requests_count ?? 0) +
                (userBadges?.refund_requests_count ?? 0) + 
                (userBadges?.merchandise_awaiting_fan_confirmation_count ?? 0) +
                (userBadges?.experience_awaiting_fan_confirmation_count ?? 0)
              }}
            </div>
          </a>
        </li>
        <li
          *ngIf="
            showLoggedInNav &&
            (((permissionKeys.INSIGHTS | hasPermission | async) &&
              ((permissionKeys.VIEW_EARNING_METRICS
                | hasPermission: PERMISSION_TYPE.READ : true
                | async) ||
                (permissionKeys.VIEW_ENGAGEMENT_METRICS
                  | hasPermission: PERMISSION_TYPE.READ : true
                  | async) ||
                (permissionKeys.ACCESS_USER_SEGMENTATION
                  | hasPermission: PERMISSION_TYPE.READ : true
                  | async) ||
                (permissionKeys.FAN_MANAGEMENT
                  | hasPermission: PERMISSION_TYPE.READ : true
                  | async)) &&
              !userProfile?.is_white_label) ||
            userProfile?.is_host_owner) && (userProfile | showTabByApproval : SIDEBAR_TABS.INSIGHTS)
          "
        >
          <a
            [class.active]="isActive('/insights')"
            (click)="setInsightsState()"
          >
            <em class="icon-metrics"></em>
            <span>{{ SIDEBAR_CONSTANTS.labels.INSIGHTS_AND_FANS }}</span>
          </a>
        </li>
        <li
          *ngIf="
            showLoggedInNav &&
            (((permissionKeys.RESOURCES | hasPermission | async) &&
              !userProfile?.is_white_label) ||
            userProfile?.is_host_owner) && (userProfile | showTabByApproval : SIDEBAR_TABS.RESOURCES) 
          "
        >
          <a
            [routerLink]="[appRoutingUrl.RESOURCES]"
            [ngClass]="{ active: getRouteStatusForResources }"
          >
            <em class="icon-liteCreator-resource-1"></em>
            <span>{{Fields.RESOURCES}}</span>
            <div
            *ngIf="totalResourcesCount"
            class="sidebar-nav-notification number-count"
          >
            {{
              totalResourcesCount
            }}
          </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <app-creator-requirements-modal
    #creatorRequirementsModal
  ></app-creator-requirements-modal>
</ng-container>
